<template>
  <div class="retail-hotel-card-container">
    <div class="retail-hotel-card-image-container">
      <ImageSlider
        :hotelid="parseInt(hotel.id)"
        :images="hotel.images"
      />
    </div>
    <div class="retail-hotel-info">
      <div class="retail-hotel-details">
        <div class="retail-hotel-title">
          <h5>{{ hotel.name }}</h5>
        </div>
        <p>{{ hotel.fullAddress }}</p>
        <p v-if="hotel.directions">
          {{ hotel.directions.distance.text }} to {{ this.$store.state.hotel.venue }}
        </p>
        <div class="retail-hotel-rating">
          <p class="rate">
            {{ hotel.rating ? hotel.rating.toFixed(1) : '0.0' }}
          </p>
          <p class="review-count small">
            {{ hotel.reviews }} {{ $t('h4h.userReviews') }}
          </p>
        </div>
      </div>
      <div class="retail-hotel-purchasing">
        <div class="retail-hotel-pricing">
          <span class="price">
            <CurrencyConvert
              :amount="price / hotel.stayDuration"
              :currency="'USD'"
            />
          </span>
          <span class="per-night">{{ $t('h4h.perNight') }}</span>
          <span class="total-price">
            <CurrencyConvert
              :amount="price"
              :currency="'USD'"
            />
            {{ $t('h4h.contractedTotal', {
              checkIn: checkIn,
              checkOut: checkOut
            }) }}
          </span>
        </div>
        <div class="retail-hotel-show-btn">
          <div
            class="btn btn-secondary room-select-btn"
            @click="selectSpecifiedHotel(hotel)"
          >
            {{ $t('h4h.chooseRoom') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/prop-name-casing */
import ImageSlider from '../../image_slider'
import Hotel from '../../../classes/hotel'
import { CurrencyConvert } from '../../../default/currency_convert'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    ImageSlider,
    CurrencyConvert,
  },
  props: {
    id: {
      default: null,
      type: Number
    },
    hotel: {
      default: null,
      type: Hotel
    }
  },

  data() {
    return {
      address: String
    }
  },

  computed: {
    ...mapGetters('hotel', ['getLowestValue', 'getCheckInDate', 'getCheckOutDate']),
    price() {
      return this.getLowestValue(this.hotel.id)
    },
    checkIn(){
      return this.getCheckInDate.slice(0,5)
    },
    checkOut(){
      return this.getCheckOutDate.slice(0,5)
    },
    hotelLocation(){
      return {lat:this.hotel.latitude, lng:this.hotel.longitude}
    },
  },

  methods: {
    ...mapMutations('hotel', ['selectHotel', 'deselectHotel']),

    selectSpecifiedHotel(hotel){
      this.selectHotel(hotel)
      window.history.pushState(hotel.id, null, `hotels#${hotel.id}`)
      window.addEventListener('popstate', (e)=>{
        e.state !== null ? this.selectHotel(hotel) : this.selectHotel(null)
      })
    }
  }
}
</script>
